export default {
  computed: {
    company() {
      return this.$page.props.auth.company
    },

    defaultLocationName() {
      return this.company.settings?.default_location_name || 'Default Store'
    },

    companyTimezone() {
      return this.company.timezone
    }
  }
}
